export class Credentials {
    constructor(name, phone, rememberMe) {
        this.name = name;
        this.phone = phone;
        this.rememberMe = rememberMe;
    }
}
